/* eslint-disable ember/no-computed-properties-in-native-classes */
import { computed } from '@ember/object';

import FilterConstants from '../../../filter-constants';
import FirstOrderLowPass from './low-pass/main';
import FirstOrderHighPass from './high-pass/main';
import BaseImplementation from '../base-implementation';
import * as CommonUtils from '../../../utils/common';

export default class FirstOrderImplementation extends BaseImplementation {
  filter;
  preferredAlgorithm;
  stageFp;
  gain;
  frequencyArray;
  name = FilterConstants.implementationType.firstOrder;

  @computed('algorithm', 'filter', 'frequencyArray', 'gain', 'stageFp', 'stageQ') get instance() {
    var filter = this.filter;
    var stageFp = this.stageFp;
    var stageQ = this.stageQ;
    var gain = this.gain;
    var frequencyArray = this.frequencyArray;
    var result = null;
    var algorithm = this.algorithm;

    var hash = { stageFp: stageFp, stageQ: stageQ, gain: gain, frequencyArray: frequencyArray, algorithm: algorithm };
    if (filter.name === FilterConstants.filterType.lowPass) {
      result = FirstOrderLowPass.create(hash);
    } else if (filter.name === FilterConstants.filterType.highPass) {
      result = FirstOrderHighPass.create(hash);
    } else {
      throw 'Filter type not supported';
    }

    return result;
  }

  @computed('filter', 'name', 'preferredAlgorithm') get algorithm() {
    var filter = this.filter;
    var name = this.name;
    var preferredAlgorithm = this.preferredAlgorithm;

    if (!CommonUtils.isNullOrUndefined(preferredAlgorithm)) {
      if (name === FilterConstants.implementationType.sallenKey && filter.name === FilterConstants.filterType.lowPass) {
        const algorithm = preferredAlgorithm[`${name}|${filter.name}`];
        return algorithm;
      } else {
        return filter.name.toLowerCase();
      }
    } else {
      if (name === FilterConstants.implementationType.sallenKey && filter.name === FilterConstants.filterType.lowPass) {
        return FilterConstants.model.inputs.components.defaultAlgorithm['sallenKey|lowPass'];
      } else {
        return filter.name.toLowerCase();
      }
    }
  }

  getStepValues(idealStep, circuit, timeAxis) {
    return this.instance.getStepValues(idealStep, circuit, timeAxis);
  }

  createCircuit(stageFp, gain, stageQ, optimization, initialCapacitorValue) {
    return this.instance.createCircuit(stageFp, gain, stageQ, optimization, initialCapacitorValue);
  }

  createBigHugeCircuitGroup(circuit, toleranceInput) {
    return this.instance.createBigHugeCircuitGroup(circuit, toleranceInput);
  }

  getInterestingCircuits(commercialCircuit, toleranceInput) {
    return this.instance.getInterestingCircuits(commercialCircuit, toleranceInput);
  }
}
